import { Endpoints } from "constants/endpoints";
import type { AffectationAntenneDto, Antenne } from "models";
import { collectivitesApiClient } from "./apiClients";

/**
 * Récupère toutes les antennes
 * @returns Array<Antenne>
 */
async function getAll(): Promise<Array<Antenne>> {
  const url = Endpoints.ANTENNES;
  const antennes: Array<Antenne> = await collectivitesApiClient.get(url);
  return antennes.toSorted((a, b) => a.libelle.localeCompare(b.libelle));
}

/**
 * Retourne les détails d'un antenne.
 * @param idAntenne Identifiant de l'antenne.
 * @returns Antenne
 */
async function getById(idAntenne: string): Promise<Antenne> {
  const url = `${Endpoints.ANTENNES}/${idAntenne}`;
  return await collectivitesApiClient.get(url);
}

/**
 * Modifie les affectations de communes d'une antenne
 * @param idAntenne Identifiant de l'antenne.
 * @param payload
 * @param payload.idAntenne Identifiant de l'antenne.
 * @param payload.idsCommune Liste des codes INSEE des communes affectées à l'antenne.
 * @returns Antenne
 */
async function affectationCommunes(
  idAntenne: string,
  payload: AffectationAntenneDto
): Promise<Antenne> {
  const url = `${Endpoints.ANTENNES}/${idAntenne}/affectation-communes`;
  return collectivitesApiClient.post(url, payload);
}

export const antennesServices = {
  getAll,
  getById,
  affectationCommunes,
};
